import { render, staticRenderFns } from "./feedback-widget.vue?vue&type=template&id=47a473ce&"
import script from "./feedback-widget.ts?vue&type=script&lang=js&"
export * from "./feedback-widget.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports